export const BODY_FONT = 'Nunito Sans'
export const TITLE_FONT = 'Poppins'

export function splitLines(
  ctx: CanvasRenderingContext2D,
  text: string | number | undefined,
  maxWidth: number,
  firstMaxWidth?: number
): string[] {
  if (!text) return []
  const words = String(text).split(' ')
  let line = ''
  const lines = []
  let currentMaxWidth = Math.max(firstMaxWidth ?? 0, 0) || maxWidth

  for (let i = 0; i < words.length; i++) {
    let test = words[i]
    let metrics = ctx.measureText(test)
    while (metrics.width > currentMaxWidth) {
      // Determine how much of the word will fit
      test = test.substring(0, test.length - 1)
      metrics = ctx.measureText(test)
    }
    if (words[i] != test) {
      words.splice(i + 1, 0, words[i].substr(test.length))
      words[i] = test
    }

    test = line + words[i] + ' '
    metrics = ctx.measureText(test)
    if (metrics.width > currentMaxWidth && i > 0) {
      lines.push(line)
      currentMaxWidth = maxWidth
      line = words[i] + ' '
    } else {
      line = test
    }
  }

  lines.push(line)
  return lines
}

export function wrapText(
  ctx: CanvasRenderingContext2D,
  text: string | number | undefined,
  x: number,
  y: number,
  maxWidth: number,
  {
    lineHeight = 22,
    decreaseIndent = false,
    strike = false,
    firstMaxWidth
  }: {
    lineHeight?: number
    decreaseIndent?: boolean
    strike?: boolean
    firstMaxWidth?: number
  } = {}
): number {
  const lines = splitLines(ctx, text, maxWidth, firstMaxWidth)
  for (let i = 0; i < lines.length; ++i) {
    if (i > 0 && decreaseIndent) {
      x = 0
    }
    ctx.fillText(lines[i], x, y)
    if (strike) {
      const metrics = ctx.measureText(lines[i])
      ctx.fillRect(x, y - lineHeight / 2, metrics.width, 2)
    }
    y += lineHeight
  }
  return lines.length
}
